window.addEventListener('DOMContentLoaded', () => {
  const voiceCards = document.querySelectorAll('[data-js="voice-group__card"]');
  const voicePopup = document.querySelector('[data-js="voice-popup"]');
  const voiceBackdrop = document.querySelector('[data-js="voice-backdrop"]');

  voiceCards.forEach((voiceCard) => {

    const voiceBtn = voiceCard.querySelector('[data-js="voice-btn"]');
    const voiceIframe = voiceCard.querySelector('[data-js="voice-iframe"]');

    voiceBackdrop.addEventListener('click', () => {
      voicePopup.classList.add('display-none');
      voiceBackdrop.classList.add('display-none');

      voicePopup.innerHTML = '';
    })

    voiceBtn.addEventListener('click', (event) => {
      event.preventDefault();
      voicePopup.innerHTML = voiceIframe.innerHTML;

      voicePopup.classList.remove('display-none');
      voiceBackdrop.classList.remove('display-none');
    })
  })
});
